import { BREAKPOINT_KEYS, BREAKPOINT_VALUES_PX } from '@/helpers/constants'
import { useUiStore } from '@/stores/ui'
import { useMemo } from 'react'

/**
 * Hook to get the current breakpoint key based on the root element width
 * - SM: 0px to MD breakpoint
 * - MD: MD breakpoint (768px) to LG breakpoint (1024px)
 * - LG: LG breakpoint (1024px) and above
 */
export const useBreakPoint = () => {
  const rootElementWidth = useUiStore(state => state.rootElementWidth)

  const matchingBreakPointKey = useMemo(() => {
    if (rootElementWidth >= BREAKPOINT_VALUES_PX.LG) {
      return BREAKPOINT_KEYS.LG
    }
    // NOTE: MD breakpoint is 768px to LG breakpoint
    if (rootElementWidth >= BREAKPOINT_VALUES_PX.MD) {
      return BREAKPOINT_KEYS.MD
    }
    // NOTE: SM breakpoint is 0px to MD breakpoint
    return BREAKPOINT_KEYS.SM
  }, [rootElementWidth])

  return matchingBreakPointKey
}
